/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Agent_Authorization_Signing_In_AsInputs */

const en_agent_authorization_signing_in_as = /** @type {(inputs: Agent_Authorization_Signing_In_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Authorizing as ${i?.email}`)
};

const zh_agent_authorization_signing_in_as = /** @type {(inputs: Agent_Authorization_Signing_In_AsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在以 ${i?.email} 授权`)
};

/**
* | output |
* | --- |
* | "Authorizing as {email}" |
*
* @param {Agent_Authorization_Signing_In_AsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_signing_in_as = /** @type {((inputs: Agent_Authorization_Signing_In_AsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Signing_In_AsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_signing_in_as(inputs)
	return zh_agent_authorization_signing_in_as(inputs)
});
export { agent_authorization_signing_in_as as "agent.authorization.signing_in_as" }